import { deleteCustomsOfficeOfTransitV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function deleteCustomsOfficeOfTransit(id: number): Promise<void> {
  await deleteCustomsOfficeOfTransitV2(id)
}
